import React,{useState,useEffect} from "react";
import { configData } from "../config";
import Loading from './Loading';
import { Helmet } from 'react-helmet';
import { Link, useNavigate,useLocation,useParams  } from 'react-router-dom';
import SalespersonSidebar from "./SalespersonSidebar";



const DeleteProduct = () => {
    
    const [isLoading, setIsLoading] = useState(true);    
    const location  = useLocation();
    const drupal_uid = localStorage.getItem('drupal_uid');
    const drupal_domain_url = configData.DRUPAL_DOMAIN_URL;
    var loggedin_domain = drupal_domain_url;
    if(localStorage.getItem('loggedin_domain')) {
    loggedin_domain = localStorage.getItem('loggedin_domain');
    } 
    var {id} = useParams();
   
    const navigate = useNavigate();
    const app_url = configData.APP_URL;
   
    useEffect(() => {
        Promise.all([
        checkproductsatus(id)
        ])
        .then(() => {
        
        setIsLoading(false);
        })
    }, []);
        
      const [errors, setErrors] = useState([]);          
      const[success,setSuccess] = useState('');
      const [canDelete, setCanDelete] = useState(false);
      async function checkproductsatus(id) {
        const response = await fetch(
          app_url+'smwwcommerceproduct/checkproductpaid?id='+id,
          {
            method: "GET",
      
            headers: {
              'Content-Type': 'application/json',
            },
          }
        )           
        const responsedata = await response.json();
          if(responsedata.data.msg === "Already Paid") {
            setCanDelete(false);
     
          } else {
            setCanDelete(true);
          }
           
        }
  const handleDelete = async (e) => {
    e.preventDefault();
    const formData = {
      id:id
    }
    const response = await fetch(app_url+'smwwcommerceproduct/deleteproductdetails', {
          method: 'POST',
          body: JSON.stringify(formData),
          headers: {
            'Content-Type': 'application/json',
          },
          });
          const data = await response.json();
          if(data.data.msg === "Success") {
            navigate('/admin/smww-commerce/product-list', { state: { message: data.data.result } });
          }
         
        
  };

  const handleCancel = (e) => {
    e.preventDefault();
    // Your cancel logic here
    window.location.href = "/admin/smww-commerce/product-list";
  };
 
    return(
          <>
                    {isLoading ? (
                        <Loading />
                    ) : (
                <div id="main">
                     <Helmet>
                        <title>
                            Delete Product
                        </title>
                    </Helmet>
                    <div className="left"></div>
                    <div className="center left-center">
                        <div className="create-scout-report-container">
                          
                        {errors.length > 0 && (
                          <div className="set-message-error" style={{ background: `#fef5f1 url("/basic/web/images/message-24-error.png") left 10px top 8px no-repeat`}}>
                          {errors.map((item, index) => {
                          return <>{item}<br /></>
                          
                        })}  
                          </div>
                        )}
                        {success && (
                          <div className="set-message-done">
                            <span className="cart-message-icon message-icon"><i className="fa fa-check-circle"></i></span><span dangerouslySetInnerHTML={{__html: success}}></span>
                          </div>                         
                      
                        )}
                         {/* Block 1: Confirm Delete */}
                                {canDelete && (
                                    <div>
                                    Are you sure you want to delete this product?
                                    <br /><br />
                                    <form method="post" onSubmit={handleDelete} name="delete">
                                        <input
                                        type="submit"
                                        id="delete-submit"
                                        name="op"
                                        value="Yes"
                                        style={{ width: '155px', height: '30px' }}
                                        className="form-submit"
                                        />&nbsp;&nbsp;&nbsp;
                                        <input
                                        type="button"
                                        id="cancel-submit"
                                        name="delete"
                                        value="No"
                                        onClick={handleCancel}
                                        style={{ width: '155px', height: '30px' }}
                                        className="form-submit"
                                        />
                                    </form>
                                    </div>
                                )}

                                {/* Block 2: Cannot Delete */}
                                {!canDelete && (
                                    <div>
                                    You cannot delete this product, it has already been purchased.
                                    <br /><br />
                                    <form>
                                        <input
                                        type="button"
                                        value="Go back!"
                                        className="form-submit"
                                        onClick={() => {
                                            window.location.href = "/admin/smww-commerce/product-list";
                                        }}
                                        />
                                    </form>
                                    </div>
                                )}
                                                
                                    </div>

    </div>
    <div className="right">
        <SalespersonSidebar/>
    </div>
    </div>
    )}
    </>
    );
};

export default DeleteProduct;

